module.exports = __webpack_public_path__ + "static/CK_FCC_GUITAR-d77fa33e71f6710e9942d6fb09a0d1cb.jpg";